import {} from "@mui/material";
import type React from "react";
import type { AdminDeliveryProposalCreatePageProps } from "../model";
import { DeliveryProposalCreateInProgress } from "./in-progress";
import { DeliveryProposalCreatePreview } from "./preview";

export const AdminDeliveryProposalCreatePageUi: React.FC<
  AdminDeliveryProposalCreatePageProps
> = (props) => {
  if (props.previewValues) {
    return <DeliveryProposalCreatePreview {...props} />;
  }
  return <DeliveryProposalCreateInProgress {...props} />;
};
